export const PXPullPlanner = (function () {
	'use strict';

	let pullPlannerForm;
	let pullPlannerFormSubmitButton;
	let userMessage;
	let username;
	let keycode;
	let pullPlannerBlock;

	function init() {
		if (!document.getElementById('pullPlannerForm')) return;

		pullPlannerBlock = document.querySelector('.pxblock--pull-planner');
		pullPlannerForm = document.getElementById('pullPlannerForm');
		pullPlannerFormSubmitButton = pullPlannerForm.querySelector('[type="submit"]');

		let zipEl = pullPlannerForm.querySelector('[data-freedom-select]');
		let countrySelect = pullPlannerForm.querySelector('#pullPlannerCountry');
		let licenseAgreement = pullPlannerForm.querySelector('#pullPlannerLicenseAgreement');

		// countrySelect.addEventListener('change', (ev) => {
		// 	if (ev.target.value === 'United States') {
		// 		zipEl.classList.add('visible');
		// 		zipEl.setAttribute('required', true);
		// 	} else {
		// 		zipEl.classList.remove('visible');
		// 		zipEl.removeAttribute('required');
		// 	}
		// });

		licenseAgreement.addEventListener('click', (ev) => {
			ev.target.checked
				? pullPlannerFormSubmitButton.removeAttribute('disabled')
				: pullPlannerFormSubmitButton.setAttribute('disabled', true);
		});

		pullPlannerForm.addEventListener('submit', (ev) => {
			ev.preventDefault();

			updateFormValues();

			var description = document.querySelector('.pxblock--pull-planner .description');
			description.style.display = 'none';

			let formData = new FormData(pullPlannerForm);
			let params = new URLSearchParams();
			let userMessageParams = new URLSearchParams();
			let hubspotEndpoint = 'https://api.hsforms.com/submissions/v3/integration/submit/6060295/bc8a1a51-0548-4467-97b5-339f37ab023a';
			let hubspotData = {
				fields: [
					{
						name: 'license',
						value: 'Agreed',
					},
				],
			};

			params.append('action', 'pull_planner_form');
			userMessageParams.append('action', 'pull_planner_download_message');
			userMessageParams.append('email', pullPlannerForm.elements['pull_planner_email'].value);
			userMessageParams.append('message', userMessage);
			userMessageParams.append('username', username);
			userMessageParams.append('keycode', keycode);

			for (const entry of formData.entries()) {
				hubspotData.fields.push({
					name: entry[0].replace('pull_planner_', ''),
					value: entry[1],
				});

				params.append(entry[0], entry[1]);
			}

			pullPlannerFormSubmitButton.setAttribute('disabled', true);

			// console.log(hubspotData);

			// axios
			// 	.post(PXConstants.ajaxUrl, userMessageParams)
			// 	.then((data) => {
			// 		if (data.status === 200) pullPlannerBlock.classList.add('form-success');
			// 	})
			// 	.catch((err) => {
			// 		pullPlannerBlock.classList.add('form-error');
			// 	});

			axios
				.post(hubspotEndpoint, hubspotData)
				.then((data) => {
					console.log(data);
					pullPlannerBlock.classList.add('form-success');
					pullPlannerFormSubmitButton.removeAttribute('disabled');
				})
				.catch((error) => {
					// 😨
					if (error.response) {
						console.log(error.response.data);
						console.log(error.response.status);
						console.log(error.response.headers);
					} else if (error.request) {
						console.log(error.request);
					} else {
						console.log('Error', error.message);
					}
					console.log(error.config);
					pullPlannerBlock.classList.add('form-error');
				});

			// axios
			// 	.post(PXConstants.ajaxUrl, params)
			// 	.then((data) => {
			// 		console.log(data);
			// 		pullPlannerFormSubmitButton.removeAttribute('disabled');
			// 	})
			// 	.catch((err) => console.log(err));

			// MicroModal.close('polywater-modal-share');
		});
	}

	/**
	 * Generates a KeyCode
	 * @param firstName
	 * @param lastName
	 * @param serialNumber
	 * @returns {string}
	 */
	function generateKeyCode({firstName, lastName, serialNumber}) {
		const firstNameSanitized = firstName.replace(/\s+/g, '').toUpperCase();
		const lastNameSanitized = lastName.replace(/\s+/g, '').toUpperCase();
		const fullName = firstNameSanitized + ' ' + lastNameSanitized;
		const FIRST_TWO = fullName.length > 45 ? 99 : fullName.length + 24;
		let LEFT = fullName
			.split('')
			.splice(0,4)
			.reduce((sumASCII, character) => {
				return sumASCII += character.charCodeAt(0);
			}, 0);
		LEFT = LEFT > 1000 ? LEFT/1000 : LEFT < 100 ? LEFT*100 : LEFT;
		let RIGHT = fullName
			.split('')
			.splice(-3)
			.reduce((sumASCII, character) => {
				return sumASCII += character.charCodeAt(0);
			}, 0);
		RIGHT = RIGHT > 1000 ? RIGHT/1000 : RIGHT < 100 ? RIGHT*100 : RIGHT;
		return `${FIRST_TWO}${LEFT}${serialNumber}${RIGHT}`;
	}

	function updateFormValues() {
		let fullName =
			pullPlannerForm.elements['pull_planner_firstname'].value.toUpperCase() +
			' ' +
			pullPlannerForm.elements['pull_planner_lastname'].value.toUpperCase();
		let nameArray = Array.from(fullName).filter((char) => char !== ' ');
		let firstFour = nameArray.slice(0, 4);
		let lastThree = nameArray.slice(nameArray.length - 3);
		let kcode = fullName.length + 24;
		let letterSum = 0;
		let serialNumber = +pullPlannerForm.elements['pp_serial_number_clone_'].value + 1;
		let d = new Date();
		let m2 = '' + (d.getMonth() + 1);
		let d2 = '' + d.getDate();
		let year = d.getFullYear();
		let version = '1.105';
		let stringifiedSerial = '' + serialNumber;
		let market = '';

		while (stringifiedSerial.length < 5) {
			stringifiedSerial = '0' + stringifiedSerial;
		}

		updateSerialNumber(stringifiedSerial);

		firstFour.forEach((letter) => (letterSum += letter.charCodeAt(0)));

		kcode += '' + letterSum;
		kcode += '' + stringifiedSerial;
		letterSum = 0;
		lastThree.forEach((letter) => (letterSum += letter.charCodeAt(0)));
		kcode += '' + letterSum;

		m2 = m2.length > 1 ? m2 : '0' + m2;
		d2 = d2.length > 1 ? d2 : '0' + d2;

		let hubspotDate = year + '-' + m2 + '-' + d2;

		switch (market) {
			case 'ELEC':
				version += 'E';
				break;

			case 'COMM':
				version += 'C';
				break;

			default:
				break;
		}

		userMessage = '';
		username = fullName;
		//keycode = kcode; //kcode value is dead above;
		keycode = generateKeyCode({
			firstName: pullPlannerForm.elements['pull_planner_firstname'].value,
			lastName: pullPlannerForm.elements['pull_planner_lastname'].value,
			serialNumber: serialNumber
		});

		pullPlannerForm.elements['pp_serial_number_clone_'].value = stringifiedSerial;
		pullPlannerForm.elements['pp_keycode_clone_'].value = keycode;
		pullPlannerForm.elements['pp_download_date_clone_'].value = hubspotDate;
	}

	function updateSerialNumber(serial) {
		let params = new URLSearchParams();

		params.append('action', 'update_pull_planner_serial');
		params.append('serial', serial);

		axios.post(PXConstants.ajaxUrl, params);
	}

	return {
		init: init,
	};
})();
